export const MONTHS = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  10: 'October',
  11: 'November',
  12: 'December'
}

export const NUMS = {
  0: '\u06F0',
  1: '\u06F1',
  2: '\u06F2',
  3: '\u06F3',
  4: '\u06F4',
  5: '\u06F5',
  6: '\u06F6',
  7: '\u06F7',
  8: '\u06F8',
  9: '\u06F9'
}

//export const BASE_URL = 'https://www.iranrights.org'
//export const BASE_URL = 'https://staging.bfiran.org'

//when sending build files, use this one and comment out the other two:
export const BASE_URL = ''
